import type {ISubscribeToChecksums} from "modules/sagas/live_score";
import {createAction} from "redux-act";

export const fetchChecksumsJSON = createAction();

type TChecksum = Record<string, string>;
export const fetchChecksumsJSONSuccess = createAction<TChecksum>();
export const fetchChecksumsJSONFailed = createAction();

export const subscribeToLiveScores = createAction<ISubscribeToChecksums>();
export const unsubscribeFromLiveScores = createAction();
